import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ConfigurationService } from './configuration-service';
import { HttpClient } from '@angular/common/http';

@NgModule({
	declarations: [],
	imports: [
		CommonModule
	]
})
export class ConfigurationModule {
	static forRoot(configurazioneModulo: any): ModuleWithProviders<ConfigurationModule> {
		let http: HttpClient;
		return {
			ngModule: ConfigurationModule,
			providers: [
				{
					provide: ConfigurationService,
					useFactory: () => new ConfigurationService(configurazioneModulo)
				}
			]
		}
	}
}